import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const MadeRightRoot = styled('section', {
  padding: '$5 $3 $5 $3',
  background: '$tertiary-200',

  '@bp2': {
    padding: '$8 $4 $8 $4',
  },
})

export const FoodOption = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '$1',
  borderBottom: '1px solid $accent-black',
  padding: '$4 0',
  '&:first-child': {
    borderTop: '2px solid $accent-black',
  },
  '&:last-child': {
    borderBottom: '2px solid $accent-black',
  },
})

export const FoodBox = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '$4',
  width: '100%',
  maxWidth: '500px',
  '@bp2': {
    maxWidth: '950px',
  },
})

export const ButtonBox = styled('div', {
  width: '100%',
  textAlign: 'center',
  paddingTop: '$4',
})

export const Span = styled('span', {
  fontWeight: '$bold',
})

export const Header = styled(Text, {
  width: '100%',
  fontFamily: '$display !important',
})
